import { estimateStringWidth } from '@shopify/polaris-viz-core';
import { PREVIEW_ICON_SIZE } from '../../../constants.js';
import { LEGEND_ITEM_LEFT_PADDING, LEGEND_ITEM_GAP, LEGEND_ITEM_RIGHT_PADDING } from '../constants.js';

function estimateLegendItemWidth(text, characterWidths) {
  const stringWidth = estimateStringWidth(text, characterWidths);
  return LEGEND_ITEM_LEFT_PADDING + PREVIEW_ICON_SIZE + stringWidth + LEGEND_ITEM_GAP + LEGEND_ITEM_RIGHT_PADDING;
}

export { estimateLegendItemWidth };
